import { ProductLineCodesTypes } from '@cemex-core/cmx-api/models/business-lines/product-lines-codes';
import { PRODUCT_LINE_CODE } from './product-lines-codes';

/*
This has been taken from the datebase:

1  0001  Bulk Cement
2  0002  Bag Cement
3  0003  Multiproduct
4  0004  Cement
5  0005  Aggregates
6  0006  Ready-Mix
7  0007  Cement Additional Service
8  0008  Aggregates Additional Service
9  0009  Ready-Mix Additional Service
10  0010  Additional Service
11  0011  Not Classified
*/

export enum PRODUCT_LINE_ID {
  BULK_CEMENT = 1,
  BAG_CEMENT = 2,
  MULTI_PRODUCT = 3,
  CEMENT = 4,
  AGGREGATES = 5,
  READY_MIX = 6,
  ADMIXTURES = 14,
}

export type ProductLineIdsTypes =
  | PRODUCT_LINE_ID.BULK_CEMENT
  | PRODUCT_LINE_ID.BAG_CEMENT
  | PRODUCT_LINE_ID.MULTI_PRODUCT
  | PRODUCT_LINE_ID.CEMENT
  | PRODUCT_LINE_ID.AGGREGATES
  | PRODUCT_LINE_ID.READY_MIX
  | PRODUCT_LINE_ID.ADMIXTURES;

const productLineIdToCodeMap = new Map<ProductLineIdsTypes, ProductLineCodesTypes>([
  [PRODUCT_LINE_ID.BULK_CEMENT, PRODUCT_LINE_CODE.BULK_CEMENT],
  [PRODUCT_LINE_ID.BAG_CEMENT, PRODUCT_LINE_CODE.BAG_CEMENT],
  [PRODUCT_LINE_ID.MULTI_PRODUCT, PRODUCT_LINE_CODE.MULTI_PRODUCT],
  [PRODUCT_LINE_ID.AGGREGATES, PRODUCT_LINE_CODE.AGGREGATES],
  [PRODUCT_LINE_ID.READY_MIX, PRODUCT_LINE_CODE.READY_MIX],
  [PRODUCT_LINE_ID.ADMIXTURES, PRODUCT_LINE_CODE.ADMIXTURES],
]);

export const transformProductLineIdToCode = (productLineId: ProductLineIdsTypes): ProductLineCodesTypes => {
  return productLineIdToCodeMap.get(productLineId);
};
